import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const listar = () => {
  return axios.get(
      `${process.env.URL_API_MENSAGEM}/message-config/listar-por-status`,
      config
    )
    .then(response => response.data)
}

const gravar = (registros) => {
  return axios.post(`${process.env.URL_API_MENSAGEM}/message-config`, registros, config)
}

export default {
  listar,
  gravar
}



// WEBPACK FOOTER //
// ./src/actions/MensagemConfigActions.js